import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListOrderRow from './ListRow/ListOrderRow'

function MyOrder() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [orders, setOrders] = useState([])

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "myOrder_view")
    const myPermissionFiscalCreate = checkPermission(myPermission, "fiscal_create")
    const myPermissionProductionView = checkPermission(myPermission, "production_view")
    const myPermissionPurchaseView = checkPermission(myPermission, "purchase_view")
    const myPermissionViewMargin = checkPermission(myPermission, "order_viewMargin")

    /* get all function */
    const getAllMy = () => {
        api.get(`/order/order/getallmy`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setOrders(response.data.myOrders)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAllMy()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return orders.filter((item) => item.client?.name?.toLowerCase().includes(searchLowerCase))
    }, [orders, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando pedidos...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Meus Pedidos</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions" />
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por cliente..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'pedido' : 'pedidos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListOrderRow
                        dataArray={filter}
                        myPermissionView={myPermissionView}
                        myPermissionFiscalCreate={myPermissionFiscalCreate}
                        myPermissionProductionView={myPermissionProductionView}
                        myPermissionPurchaseView={myPermissionPurchaseView}
                        myPermissionViewMargin={myPermissionViewMargin}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum pedido encontrado</p>
                        <p className="pg-empty-subtitle">
                            {orders.length === 0
                                ? 'Ainda não há pedidos gerados a partir dos seus orçamentos.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar pedidos</p>
        </div>
    )
}

export default MyOrder
